module.exports = __webpack_public_path__ + "img/placeholder.48bcea0d.png";